import './index.css'
import cn from 'clsx'
import dayjs from '@disco/utils/dayjs'

import React, { Component } from 'react'
import { MdSend } from '@react-icons/all-files/md/MdSend'
type Props = {
  title: string
  message: string
  date: string
  user?: {
    name: string
    email: string
  }
}
type State = {
  messageOpen: boolean
}

/**
 * PlaylistMessage component for displaying playlist messages
 *
 * A class component that displays a message card with title, content, date, and optional
 * user information. Includes expand/collapse functionality for long messages and
 * proper formatting for multi-line content.
 *
 * @param props - Component props
 * @param props.title - Message title to display
 * @param props.message - Message content body
 * @param props.date - Date string for when the message was sent
 * @param props.user - Optional user object containing name and email
 * @returns JSX element containing the formatted message card
 */
export default class PlaylistMessage extends Component<Props, State> {
  state: State = {
    messageOpen: false,
  }
  _handleToggleClick: () => void = () =>
    this.setState({
      messageOpen: !this.state.messageOpen,
    })

  render(): React.ReactElement<'div'> {
    const { message, title, date } = this.props
    let userBlock: React.ReactNode = null

    if (this.props.user) {
      const { email } = this.props.user
      const dateString = (dayjs(date) as any).fromNow()
      userBlock = (
        <div className="UserCard">
          <div className="UserCard_Details">
            {/* TODO: re-enable name */}
            {/* <div className="UserCard_Details_Name">{this.props.user.name} &nbsp;</div> */}
            <div className="UserCard_Details_Email">{email}</div>
            <div className="UserCard_Details_Date">{dateString}</div>
          </div>
        </div>
      )
    }

    const textParagraphs = message.trim().split('\n')
    const messageText = textParagraphs.map((text, index) => {
      return <p key={index}>{text}&nbsp;</p>
    })
    const messageClass = cn('Playlist_Message', {
      'is-active': this.state.messageOpen,
    })
    return (
      <div className={messageClass}>
        <div className="MessageCaption" />
        <div className="MessageContent">
          <div className="MessageCaption_Header">
            <div className="MessageIcon">
              <MdSend size={20} />
            </div>
            {userBlock}
          </div>
          <div title={title} className="MessageCaption_Title overflow-ellipsis">
            {title}
          </div>
          <div className="MessageCaption_Body">{messageText}</div>
          {this.props.message.length > 100 && (
            <div className="MessageCaption_Expand">
              <div className="MessageCaption_ExpandOverlay" />
              <button
                className="MessageCaption_ExpandBtn"
                onClick={this._handleToggleClick}
              >
                {this.state.messageOpen ? 'Read Less' : 'Read More'}
              </button>
            </div>
          )}
        </div>
      </div>
    )
  }
}
